import { Component, inject, OnInit } from '@angular/core';

import { ChartModule } from 'primeng/chart';
import { FluidModule } from 'primeng/fluid';
import { DashboardService } from '../services/api/dashboard.service';

@Component({
    selector: 'app-graphloans',
    imports: [ChartModule, FluidModule],
    templateUrl: './graphloans.component.html',
    styleUrl: './graphloans.component.scss'
})
export class GraphloansComponent implements OnInit {
    private _dashboardService = inject(DashboardService);

    lineData: any;
    lineOptions: any;
    datasets: any;
    labels: string[] = [];
    data: number[] = [];

    constructor() {}

    ngOnInit(): void {
        this._dashboardService.getDatosGraphBranches().subscribe((resp) => {
            if (resp.status) {
                console.log(resp);

                this.datasets = resp.object;

                this.datasets.forEach((element: any) => {
                    this.labels.push(element.branchName);
                    this.data.push(element.orderCount);
                });

                console.log(this.labels, this.data);
                this.initCharts();
            }
        });
    }

    initCharts() {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

        this.lineData = {
            // labels: ['Caacupé', 'Capiata', 'Carapegua', 'Centro', 'Itauguá', 'Laboratorio', 'Lambaré', 'Luque', 'MRA', 'Ñemby', 'San Lorenzo', 'San Pablo'],
            labels: this.labels,
            datasets: [
                {
                    label: 'Ordenes Emitidas',
                    // data: [10, 35, 15, 70, 50, 10, 75, 100, 120, 90, 135, 88],
                    data: this.data,
                    fill: false,
                    backgroundColor: documentStyle.getPropertyValue('--p-primary-500'),
                    borderColor: documentStyle.getPropertyValue('--p-primary-500'),
                    tension: 0.4
                }
            ]
        };

        this.lineOptions = {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    }
                },
                y: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    }
                }
            }
        };
    }
}
